import { API_BASE_URL } from 'config';
import { USER_TOKEN, USER_VIEW_MODE } from 'helpers/storage';
import { getA11yButton } from './plugins/a11y';
import { getFormulaButton } from './plugins/formula';
import { getAiButton } from './plugins/aiAssistant';
import { getInteractiveGroupButton } from './widgets';

const PRIMARY_BUTTONS = [
  'undo',
  'redo',
  '|',
  'paragraph',
  '|',
  'bold',
  'italic',
  '|',
  'left',
  'center',
  'right',
  'justify',
  '|',
  'ul',
  'ol',
  '|',
  'outdent',
  'indent',
  '|',
  'link',
  'image',
];

export const MENU_ONLY_BUTTONS = [
  'cut',
  'copy',
  'paste',
  'selectall',
  'find',
  'eraser',
  'underline',
  'strikethrough',
  'superscript',
  'subscript',
  'font',
  'fontsize',
  'brush',
  'lineHeight',
  'video',
  'file',
  'table',
  'hr',
  'symbols',
  'source',
  'fullsize',
  'preview',
  'print',
];

export const buildJoditConfig = ({
  disabled,
  height,
  width,
  placeholder,
  dispatch,
  enableInteractiveWidgets,
  courseId,
  onAfterInit,
  onChange,
}) => {
  const extraButtons = enableInteractiveWidgets
    ? [getInteractiveGroupButton()]
    : [];

  return {
    readonly: disabled,
    height,
    width,
    placeholder,
    toolbarAdaptive: false,
    toolbarSticky: false,
    toolbarButtonSize: 'small',
    spellcheck: true,
    showXPathInStatusbar: false,
    hidePoweredByJodit: true,
    mcCourseId: courseId || '',
    cleanHTML: {
      removeEmptyElements: false,
      fillEmptyParagraph: false,
    },
    uploader: {
      insertImageAsBase64URI: false,
      url: `${API_BASE_URL}/users-file?type=editor`,
      headers: {
        Authorization: USER_TOKEN.get(),
        Role: USER_VIEW_MODE.get(),
      },
      prepareData: (formData) => {
        const file = formData.getAll('files[0]')[0];
        formData.delete('files[0]');
        formData.append('users-file', file);
        return formData;
      },
      isSuccess: (resp) => resp && typeof resp.location === 'string',
      getMessage: (resp) => resp?.location || 'Upload failed',
      process: (resp) => ({
        files: [resp.location.split('/').pop()],
        isImages: [true],
        baseurl: resp.location.replace(/\/[^/]+$/, '/'),
      }),
    },
    buttons: [
      ...PRIMARY_BUTTONS,
      getAiButton(dispatch),
      ...extraButtons,
      getFormulaButton(),
      getA11yButton(),
      ...MENU_ONLY_BUTTONS,
    ],
    removeButtons: ['ai-assistant', 'ai-commands', 'about'],
    events: {
      afterInit: onAfterInit,
      change: onChange,
    },
  };
};
